module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservations d-flex flex-column"
  }, [_c('div', [_c('navigator', {
    on: {
      "mainFilterChanged": _vm.mainFilterChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 flexGrow1 overflow-auto"
  }, [_c(_vm.selectedAreaName, {
    tag: "component",
    attrs: {
      "reservationMainFilters": _vm.navigatorFilters || {},
      "pagination": _vm.pagination
    },
    on: {
      "paginationChanged": _vm.paginationChanged,
      "resetPagination": _vm.resetPagination
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-30c08189", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c08189"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Reservations.vue
// module id = 2726
// module chunks = 0